import React from "react";
import "./footerCompo.scss";
import LogoContent from "../../assets/logoContent.png";
import "@fontsource/roboto";
import "@fontsource/roboto/700.css";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import HotelIcon from "@mui/icons-material/Hotel";
import InfoIcon from "@mui/icons-material/Info";

const FooterCompo = () => {
  return (
    <footer className="footer-container" style={{ fontFamily: "Roboto" }}>
      <div className="footer-top">
        <div className="footer-brand">
          <div className="footer-logo-wrapper">
            <img
              src={LogoContent}
              alt="Cinnamon Lakehouse Logo"
              className="footer-logo"
            />
          </div>
        </div>

        <div className="footer-slogan">
          <InfoIcon className="info-icon" />
          <span>
            We ensure your stay is both memorable and enjoyable. Your comfort
            and satisfaction are our top priorities.
          </span>
        </div>

        <div className="footer-contact">
          <h3>
            <HotelIcon className="contact-icon" />
            Contact
          </h3>
          <p>
            <LocationOnIcon className="location-icon" />
            <span>
              Cinnamon Lakehouse
              <br />
              Via san Zeno 27
              <br />
              Cavalcaselle, Italy
            </span>
          </p>
        </div>
      </div>

      <div className="footer-divider" />

      <div className="footer-bottom">
        <span className="copyright">
          Copyright &copy; {new Date().getFullYear()} Cinnamon Lakehouse. All
          rights reserved.
        </span>
        <span className="credits">
          Powered by Revotec Software Solutions (Pvt) Ltd
        </span>
      </div>
    </footer>
  );
};

export default FooterCompo;
